import * as React from 'react';
import { useParams } from 'react-router';
import { API_SERVER } from '../../common/api';
import { Paper } from '@mui/material';
import TablePriceBox from '../component/dental/detail/TablePriceBox';
import BasicEOCInfo from 'modules/cashier/component/dental/detail/BasicEocInfo';
import PaymentHistoryFormDialog from '../component/dental/PaymentHistoryTableDialog';
import { some } from '../../common/constants';
import PrepaymentRefundPrintDialog from '../component/dental/detail/PrintForm/PrepaymentRefundPrintDialog';
import PaymentHistoryPrintDialog from '../component/dental/detail/PrintForm/PaymentHistoryPrintDialog';
import PaymentRefundHistoryPrintDialog from '../component/dental/detail/PrintForm/PaymentRefundHistoryPrintDialog';
import { useFetch } from 'modules/common/hook';

interface Props {}

const CashierDentalDetailPage: React.FunctionComponent<Props> = (props) => {
  const { dentalId, paymentId } = useParams<{ dentalId: string; paymentId: string }>();
  const [openPaymentHistoryDialog, setOpenPaymentHistoryDialog] = React.useState(false);
  const [prepaymentRefundPrint, setPrepaymentRefundPrint] = React.useState<some>();
  const [paymentHistoryPrint, setPaymentHistoryPrint] = React.useState<some>();
  const [paymentRefundHistoryPrint, setPaymentRefundHistoryPrint] = React.useState<some>();

  const {
    data: dentalDetail,
    revalidate: revalidateDental,
    isValidating: isValidatingDentalDetail,
  } = useFetch(API_SERVER.dentalExam.getDentalExam(dentalId), { revalidateOnMount: true, revalidateOnFocus: false });

  const {
    data: paymentDetail,
    revalidate: revalidatePaymentDetail,
    isValidating: isValidatingPaymentDetail,
  } = useFetch(API_SERVER.payment.detail(parseInt(paymentId), { type: 'DENTAL' }));

  const {
    data: prepaymentDetail,
    revalidate: revalidatePrepaymentDetail,
    isValidating: isValidatingPrepaymentDetail,
  } = useFetch(API_SERVER.prepayment.getPrepayment({ paymentId: parseInt(paymentId) }), {
    revalidateOnMount: true,
    revalidateOnFocus: false,
  });

  const swrPaymentHistory = useFetch(API_SERVER.paymentHistory.getList(parseInt(paymentId)), {
    revalidateOnMount: true,
    revalidateOnFocus: false,
    enabled: openPaymentHistoryDialog,
  });

  return (
    <Paper elevation={1} style={{ overflow: 'auto', padding: 16, flex: 1 }}>
      <BasicEOCInfo data={dentalDetail} setOpenPaymentHistoryFormDialog={setOpenPaymentHistoryDialog} />
      <TablePriceBox
        paymentDetail={paymentDetail}
        therapyDetail={dentalDetail}
        prepaymentDetail={prepaymentDetail}
        paymentAdvanceList={prepaymentDetail?.paymentAdvances}
        // onApplyDiscount={onApplyDiscount}
        revalidate={() => {
          revalidateDental();
          revalidatePaymentDetail();
          revalidatePrepaymentDetail();
        }}
        loading={isValidatingDentalDetail || isValidatingPaymentDetail || isValidatingPrepaymentDetail}
      />
      <PaymentHistoryFormDialog
        open={openPaymentHistoryDialog}
        onClose={() => {
          setOpenPaymentHistoryDialog(false);
        }}
        data={swrPaymentHistory}
        onOpenPrepaymentRefundPrint={setPrepaymentRefundPrint}
        onOpenPaymentHistoryPrint={setPaymentHistoryPrint}
        onOpenPaymentRefundHistoryPrint={setPaymentRefundHistoryPrint}
      />
      <PrepaymentRefundPrintDialog
        open={!!prepaymentRefundPrint}
        prepaymentRefundPrint={prepaymentRefundPrint}
        therapyDetail={dentalDetail}
        onClose={() => {
          setPrepaymentRefundPrint(undefined);
        }}
      />
      {paymentHistoryPrint && (
        <PaymentHistoryPrintDialog
          open={!!paymentHistoryPrint}
          paymentHistoryPrint={paymentHistoryPrint}
          therapyDetail={dentalDetail}
          onClose={() => {
            setPaymentHistoryPrint(undefined);
          }}
        />
      )}
      {paymentRefundHistoryPrint && (
        <PaymentRefundHistoryPrintDialog
          open={!!paymentRefundHistoryPrint}
          paymentHistoryPrint={paymentRefundHistoryPrint}
          therapyDetail={dentalDetail}
          onClose={() => {
            setPaymentRefundHistoryPrint(undefined);
          }}
        />
      )}
    </Paper>
  );
};

export default CashierDentalDetailPage;
